// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .message-indicator[data-v-e2170122] {\n  border-left: 1px solid var(--danger);\n  padding-left: 5px;\n}[dir=rtl] .message-indicator[data-v-e2170122] {\n  border-right: 1px solid var(--danger);\n  padding-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
